import React, {useEffect, useRef} from "react";
import PropTypes from 'prop-types';

import {urlToPage} from "@shared/lib/urlToPage";

ManageAccountStep.propTypes = {
  index: PropTypes.number
}

export function ManageAccountStep(props) {
  const stepRef = useRef(null);
  const { nested = false } = props;

  // On mount, focus the step and scroll into view.
  useEffect(() => {
    if (nested) return;
    stepRef.current.focus({ preventScroll: true });
    window.scrollTo({
      top: (stepRef.current.offsetTop - 120),
      behavior: "smooth"
    });
  }, [])

  return (
    <div ref={stepRef} tabIndex={0} className={`support-form-step support-form-manage-account-step ${nested ? "support-form-step--nested" :""}`}>
      <div className="support-form-step-header">
        {!nested &&
          <div className="support-form-manage-account-step__icon-circle">
            <div className="support-form-manage-account-step__icon">
              <span className="support-form-manage-account-step__glyph glyph-core-person-fill"></span>
            </div>
          </div>
        }
        <div className="support-form-step-header__side-line" />
        {!nested && <h2 className="support-form-step-header__question">Manage your account</h2>}
        <p className="support-form-step-header__description">You can manage your account settings on the My Account page.</p>
      </div>

      <a className="support-form-manage-account-step__button" href={urlToPage('account')}>
        <span>Go to My Account</span>
        <span className="mask-arrow-right"/>
      </a>
    </div>
  );
}
